import Login from './login'

const routes = [...Login]

export default routes
